/* ══════════════════════════════════════════════════════════════════
   🔧 CART PROPS AUTO-REPAIR — v7 (v6 + stale city/pincode check)
   ══════════════════════════════════════════════════════════════════
   v7 (order #10661): mattress Delhi (203) price/city par add hua, baad me
   pincode 636009 (Salem) hua, lekin line re-price nahi hui. v6 ka Step 4
   us line par sirf hl_pin=636009 likh deta tha → order me Delhi city +
   Delhi price + Salem pincode. Ab checkout se pehle har line ka _city_id
   order pincode ki city se match hota hai; mismatch ho to wo line
   "stale" maani jaati hai → poora cart us pincode par recheck (price +
   city + state + cod_discount dobara). Recheck ke baad bhi mismatch ho
   to checkout band. Cart attribute hl_pin bhi usi pincode se sync.
   ══════════════════════════════════════════════════════════════════
   Har asli (non-gift) cart line par ye properties MANDATORY hain —
   inke bina GoKwik / native checkout nahi khulega:

     _product_id, _sw_category, _api_price,
     _city_id, _state_id, _city_name, hl_pin, _cod_discount

   Kuch carts theme ke add-to-cart flow se nahi bante (KwikEngage ka
   `/?pid=<variantId>` link — orders #10272, #10615) ya kisi flow me
   kuch properties chhoot jaati hain (Sleep Setup cross-sell me city,
   PDP me line-level hl_pin). Ye script aisi har line ko khud bharta hai:

     1. _product_id / _sw_category missing → Shopify product title se
        SW product dhundhta hai (productlist/mattress + allcross API,
        title EXACT match) + variant se _size/_length/_breadth/_thickness.
     2. Pincode lo: localStorage `kpc_pincode` → cart attribute `hl_pin`
        → nahi mila to customer se pincode popup me maango.
     3. Price / city / state / cod_discount missing → wahi
        __swRecheckCartForPincode(pin) jo pincode badalne par chalta hai
        (sw-pincode-cart-recheck.js) — ye hl_pin bhi line par likhta hai.
     4. Sirf line-level hl_pin missing (baaki sab theek) → seedha
        hl_pin set (koi API call nahi).

   Gate ke liye: window.__swCheckoutMissingItems(cart) — mandatory
   property missing wali lines lautaata hai. theme.liquid ka
   swCartReadyForGoKwik() isi se checkout rokta hai.

   Load order (layout/theme.liquid): sleep-setup-widget.js aur
   sw-pincode-cart-recheck.js ke BAAD, sw-checkout-gate.js se PEHLE.
   ══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.__swPropsRepairInit) return;
  window.__swPropsRepairInit = true;

  var API_BASE = 'https://sf-backend.mysleepwell.com';
  var MAX_MATTRESS_PAGES = 20;
  var CROSS_CATEGORIES = ['pillow', 'protector', 'sofa'];

  // ── Mandatory line properties ────────────────────────────────────
  var REQUIRED_KEYS = [
    '_product_id', '_sw_category', '_api_price',
    '_city_id', '_state_id', '_city_name', 'hl_pin', '_cod_discount'
  ];
  var IDENTITY_KEYS = ['_product_id', '_sw_category'];
  var PRICE_LOCATION_KEYS = ['_api_price', '_city_id', '_state_id', '_city_name', '_cod_discount'];

  var MAX_RUNS_PER_PAGE = 10;
  var runCount = 0;

  /* ── helpers ─────────────────────────────────────────────────── */
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function isGift(item) {
    var p = item.properties || {};
    return p._is_free_gift === 'true' || p._is_free_gift === true;
  }
  function isBlank(v) { return v == null || String(v).trim() === ''; }

  // 🆕 ₹0 GUARD — _api_price 0/negative ho, ya Shopify line price hi 0 ho
  // (cart transform _api_price<=0 par variant price use karta hai — aur
  // kuch variants ka price 0 hai), to line kabhi checkout tak nahi jaani chahiye.
  function isZeroPriceItem(item) {
    if (isGift(item)) return false;
    var p = item.properties || {};
    if (!isBlank(p._api_price) && !(parseFloat(p._api_price) > 0)) return true;
    if (item.final_price != null && !(Number(item.final_price) > 0)) return true;
    return false;
  }
  window.__swIsZeroPriceItem = isZeroPriceItem;

  /* 🆕 v7 — order pincode ki city (citybypincode se). Repair isse
     checkout se pehle bharta hai; missingKeys() isse compare karta hai. */
  var pinCity = { pin: '', cityId: '' };
  var pinCityPromise = null;
  var pinCityFor = '';

  function ensurePinCity(pin) {
    if (!validPin(pin)) return Promise.resolve(null);
    if (pinCity.pin === pin && pinCity.cityId) return Promise.resolve(pinCity);
    if (pinCityPromise && pinCityFor === pin) return pinCityPromise;
    pinCityFor = pin;
    pinCityPromise = fetch(API_BASE + '/s1/product/citybypincode/' + pin, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        d = Array.isArray(d) ? d[0] : d;
        var cid = d && d.id != null ? String(d.id).trim() : '';
        if (cid) pinCity = { pin: pin, cityId: cid };
        return pinCity;
      })
      .catch(function (e) {
        // API fail → stale check skip (pehle jaisa behaviour), checkout block nahi
        console.warn('🔧 props-repair: citybypincode failed for', pin, e);
        return null;
      })
      .finally(function () { pinCityPromise = null; });
    return pinCityPromise;
  }

  // Line kisi aur pincode/city ki hai? (_city_id ≠ order pincode city,
  // ya line ka hl_pin ≠ order pincode)
  function isStaleLocation(item) {
    if (isGift(item) || !pinCity.cityId) return false;
    var p = item.properties || {};
    if (!isBlank(p._city_id) && String(p._city_id).trim() !== pinCity.cityId) return true;
    if (validPin(p.hl_pin) && String(p.hl_pin).trim() !== pinCity.pin) return true;
    return false;
  }
  window.__swIsStaleLocationItem = isStaleLocation;

  function missingKeys(item) {
    if (isGift(item)) return [];
    var p = item.properties || {};
    var m = REQUIRED_KEYS.filter(function (k) { return isBlank(p[k]); });
    // 🆕 v7 — galat city/pincode wali line ko "_city_id missing" maano →
    // Step 3 recheck use naye pincode par re-price karega; na ho paaye to gate rokega
    if (isStaleLocation(item) && m.indexOf('_city_id') === -1) m.push('_city_id');
    // ₹0 price ko bhi "price missing" maano — repair recheck chalayega
    // (pincode par sahi price aaye to theek, warna _not_available → gate rokega)
    if (isZeroPriceItem(item) && m.indexOf('_api_price') === -1) m.push('_api_price');
    return m;
  }
  function anyMissing(item, keys) {
    var m = missingKeys(item);
    return keys.some(function (k) { return m.indexOf(k) !== -1; });
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function getCityId() {
    try { return Number(localStorage.getItem('city_id')) || 259; } catch (e) { return 259; }
  }

  function validPin(p) { return /^\d{6}$/.test(String(p || '').trim()); }

  function getPincode(cart) {
    var pin = '';
    try { pin = (localStorage.getItem('kpc_pincode') || '').trim(); } catch (e) {}
    if (!validPin(pin)) pin = String((cart && cart.attributes && cart.attributes.hl_pin) || '').trim();
    if (!validPin(pin)) {
      // kisi line par pehle se hl_pin ho to wahi
      var withPin = ((cart && cart.items) || []).find(function (it) {
        return it.properties && validPin(it.properties.hl_pin);
      });
      if (withPin) pin = String(withPin.properties.hl_pin).trim();
    }
    return validPin(pin) ? pin : '';
  }

  function savePincode(pin) {
    try {
      localStorage.setItem('kpc_pincode', pin);
      // cart-checkout-gate.liquid ka gateOk() ye flag maangta hai — warna
      // popup me pincode dene ke baad bhi cart "Please enter your pincode"
      // bol kar checkout rok deta.
      sessionStorage.setItem('sw_cart_pin_applied', '1');
      localStorage.removeItem('kpc_delivery_text'); // purane pincode ka text na dikhe
    } catch (e) {}
    // cart attribute bhi — order ke additional details me aata hai
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
      body: JSON.stringify({ attributes: { hl_pin: pin } })
    }).catch(function () {});
  }

  function changeLine(key, quantity, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
      body: JSON.stringify({ id: key, quantity: quantity, properties: properties })
    });
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ── Pincode popup (sirf tab jab pincode kahin bhi na mile) ────── */
  var pinPromptPromise = null;
  function askPincode() {
    if (pinPromptPromise) return pinPromptPromise;
    pinPromptPromise = new Promise(function (resolve) {
      var overlay = document.createElement('div');
      overlay.style.cssText =
        'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2147483647;' +
        'display:flex;align-items:center;justify-content:center;padding:16px;';
      overlay.innerHTML =
        '<div style="background:#fff;border-radius:10px;max-width:360px;width:100%;padding:20px;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.25);font-family:inherit;">' +
          '<div style="font-size:17px;font-weight:700;margin-bottom:6px;">Enter delivery pincode</div>' +
          '<div style="font-size:13px;color:#555;margin-bottom:14px;">We need your pincode to confirm price and delivery for your order.</div>' +
          '<input type="tel" inputmode="numeric" maxlength="6" placeholder="6-digit pincode" ' +
          'style="width:100%;box-sizing:border-box;padding:12px;font-size:16px;border:1px solid #bbb;border-radius:6px;" />' +
          '<div class="sw-pin-err" style="color:#c00;font-size:12px;min-height:16px;margin-top:6px;"></div>' +
          '<div style="display:flex;gap:10px;margin-top:10px;">' +
            '<button type="button" class="sw-pin-cancel" style="flex:1;padding:11px;border:1px solid #bbb;background:#fff;border-radius:6px;font-weight:600;cursor:pointer;">Cancel</button>' +
            '<button type="button" class="sw-pin-ok" style="flex:1;padding:11px;border:0;background:#1a5fb4;color:#fff;border-radius:6px;font-weight:600;cursor:pointer;">Continue</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      var input = overlay.querySelector('input');
      var err = overlay.querySelector('.sw-pin-err');
      setTimeout(function () { try { input.focus(); } catch (e) {} }, 50);

      function done(val) {
        overlay.remove();
        pinPromptPromise = null;
        resolve(val);
      }
      overlay.querySelector('.sw-pin-cancel').addEventListener('click', function () { done(''); });
      overlay.querySelector('.sw-pin-ok').addEventListener('click', function () {
        var v = String(input.value || '').replace(/\D/g, '');
        if (!validPin(v)) { err.textContent = 'Please enter a valid 6-digit pincode.'; return; }
        done(v);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') overlay.querySelector('.sw-pin-ok').click();
      });
    });
    return pinPromptPromise;
  }

  /* ── SW product lists (sirf tab fetch hote hain jab zaroorat ho) ── */
  var mattressListPromise = null;
  function loadMattressList() {
    if (mattressListPromise) return mattressListPromise;
    mattressListPromise = (async function () {
      var all = [];
      for (var pg = 1; pg <= MAX_MATTRESS_PAGES; pg++) {
        try {
          var r = await fetch(API_BASE + '/s1/shopify/productlist/mattress', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              city_id: getCityId(), pageno: pg,
              size: [], feel: [], type: [], look: [], thickness: [], series: [], benefit: [], warranty: [],
              order: 'relevance_seq', price_min: 0, price_max: 200000
            })
          });
          var d = await r.json();
          var products = (d && d.products) || [];
          if (!products.length) break;
          all = all.concat(products);
          var tp = d.total_pages || d.totalpages || (d.pagination && d.pagination.totalpages);
          if (tp && pg >= tp) break;
        } catch (e) {
          console.error('🔧 props-repair: mattress list page', pg, 'failed:', e);
          break;
        }
      }
      return all;
    })();
    return mattressListPromise;
  }

  function loadCrossList(cat) {
    return new Promise(function (resolve) {
      if (typeof window.__swFetchCategoryProductList === 'function') {
        window.__swFetchCategoryProductList(cat, function (list) { resolve(list || []); });
      } else {
        resolve([]);
      }
    });
  }

  // EXACT title match pehle; substring sirf tab jab EK hi candidate ho.
  function matchProduct(list, title) {
    var t = norm(title);
    if (!t) return null;
    var titleOf = function (p) { return norm(p.zoneTitle || p.listing_title || p.title || ''); };
    var exact = list.filter(function (p) { return titleOf(p) === t; });
    if (exact.length) return exact[0];
    var partial = list.filter(function (p) {
      var n = titleOf(p);
      return n && (n.indexOf(t) !== -1 || t.indexOf(n) !== -1);
    });
    return partial.length === 1 ? partial[0] : null;
  }

  async function resolveSwProduct(item) {
    var title = item.product_title || '';
    var m = matchProduct(await loadMattressList(), title);
    if (m && m.id != null) return { id: String(m.id), category: 'mattress' };
    for (var i = 0; i < CROSS_CATEGORIES.length; i++) {
      var cat = CROSS_CATEGORIES[i];
      var x = matchProduct(await loadCrossList(cat), title);
      if (x && x.id != null) return { id: String(x.id), category: cat };
    }
    return null;
  }

  // "Queen / 6 / 72X60" → Size, Height, Dimension
  function dimsFromVariant(item) {
    var byName = {};
    (item.options_with_values || []).forEach(function (o) { byName[norm(o.name)] = o.value; });
    var opts = item.variant_options || [];
    var size = byName.size || opts[0] || '';
    var height = byName.height || byName.thickness || opts[1] || '';
    var dim = String(byName.dimension || opts[2] || '').toUpperCase().split('X');
    var L = parseFloat(dim[0]);
    var B = parseFloat(dim[1]);
    var T = parseFloat(height);
    return {
      size: String(size),
      length: isNaN(L) ? '' : String(L),
      breadth: isNaN(B) ? '' : String(B),
      thickness: isNaN(T) ? '0' : String(T)
    };
  }

  /* ── Gate helper ─────────────────────────────────────────────── */
  window.__swCheckoutMissingItems = function (cart) {
    return ((cart && cart.items) || []).filter(function (it) {
      if (isGift(it)) return false;
      if (it.properties && it.properties._not_available === 'true') return true;
      if (isZeroPriceItem(it)) return true; // 🆕 ₹0 line → checkout band
      return missingKeys(it).length > 0;
    });
  };
  window.__swMissingKeysForItem = missingKeys;

  /* ── Main repair ─────────────────────────────────────────────── */
  var running = null;

  // opts.askPincode = true → pincode na mile to popup dikhao
  function repairCartProps(opts) {
    opts = opts || {};
    if (running) return running;
    running = (async function () {
      try {
        var cart = await getCart();

        // 🆕 v7 — order pincode ki city pehle lao (stale line pakadne ke liye)
        // aur cart attribute hl_pin ko usi pincode se sync rakho
        var pin0 = getPincode(cart);
        if (pin0) {
          await ensurePinCity(pin0);
          var attrPin = String((cart.attributes && cart.attributes.hl_pin) || '').trim();
          if (attrPin !== pin0) await savePincode(pin0);
        }

        var bad = (cart.items || []).filter(function (it) { return missingKeys(it).length > 0; });
        if (!bad.length) return true;

        if (runCount >= MAX_RUNS_PER_PAGE) {
          console.warn('🔧 props-repair: max auto runs reached for this page — skipping.');
          return false;
        }
        runCount++;

        console.warn('🔧 props-repair:', bad.length, 'line(s) missing mandatory props —',
          bad.map(function (it) { return it.product_title + ' [' + missingKeys(it).join(', ') + ']'; }));

        /* Step 1 — identity (_product_id / _sw_category) */
        for (var i = 0; i < bad.length; i++) {
          var it = bad[i];
          if (!anyMissing(it, IDENTITY_KEYS)) continue;
          var sw = await resolveSwProduct(it);
          if (!sw) {
            console.error('🔧 props-repair: SW product nahi mila for "' + it.product_title + '" — checkout gate rokega.');
            continue;
          }
          var d = dimsFromVariant(it);
          var props = Object.assign({}, it.properties || {}, {
            _product_id: sw.id,
            _sw_category: sw.category,
            _variant_id: String(it.variant_id),
            _size: d.size,
            _length: d.length,
            _breadth: d.breadth,
            _thickness: d.thickness,
            _props_source: 'auto-repair'
          });
          try {
            await changeLine(it.key, it.quantity, props);
            console.log('🔧 props-repair: "' + it.product_title + '" → _product_id ' + sw.id + ' (' + sw.category + ')');
          } catch (e) {
            console.error('🔧 props-repair: cart/change failed for', it.key, e);
          }
        }

        /* Step 2 — pincode */
        cart = await getCart();
        var pin = getPincode(cart);
        if (!pin && opts.askPincode) {
          pin = await askPincode();
          if (pin) await savePincode(pin);
        }
        if (pin) await ensurePinCity(pin); // 🆕 v7
        if (!pin) {
          console.error('🔧 props-repair: pincode nahi mila — city/state/cod_discount nahi bhar sakte. Checkout gate rokega.');
          return false;
        }

        /* Step 3 — price / city / state / cod_discount (+ hl_pin) */
        var needRecheck = (cart.items || []).some(function (it2) {
          return anyMissing(it2, PRICE_LOCATION_KEYS) && !anyMissing(it2, IDENTITY_KEYS);
        });
        if (needRecheck && typeof window.__swRecheckCartForPincode === 'function') {
          await window.__swRecheckCartForPincode(pin);
          // recheck pehle se chal raha ho to ye queue ho jaata hai —
          // cart bharne tak thoda wait karo (max ~10s)
          for (var w = 0; w < 20; w++) {
            cart = await getCart();
            var still = (cart.items || []).some(function (it3) {
              return anyMissing(it3, PRICE_LOCATION_KEYS) && !anyMissing(it3, IDENTITY_KEYS) &&
                     !(it3.properties && it3.properties._not_available === 'true');
            });
            if (!still) break;
            await sleep(500);
          }
        }

        /* Step 4 — sirf line-level hl_pin missing → seedha set */
        cart = await getCart();
        for (var j = 0; j < (cart.items || []).length; j++) {
          var it4 = cart.items[j];
          var m4 = missingKeys(it4);
          if (m4.length === 1 && m4[0] === 'hl_pin') {
            try {
              await changeLine(it4.key, it4.quantity, Object.assign({}, it4.properties || {}, { hl_pin: pin }));
            } catch (e) {
              console.error('🔧 props-repair: hl_pin set failed for', it4.key, e);
            }
          }
        }

        cart = await getCart();
        var left = window.__swCheckoutMissingItems(cart);
        if (left.length) {
          console.error('🔧 props-repair: abhi bhi incomplete:', left.map(function (it5) {
            return it5.product_title + ' [' + (missingKeys(it5).join(', ') || '_not_available') + ']';
          }));
        } else {
          console.log('🔧 props-repair: ✅ saari lines complete');
        }

        // Drawer sirf ek baar refresh — beech ke har change.js par nahi
        if (window.swRefreshCartDrawer) window.swRefreshCartDrawer({ delay: 300 });

        return left.length === 0;
      } catch (e) {
        console.error('🔧 props-repair failed:', e);
        return false;
      } finally {
        running = null;
      }
    })();
    return running;
  }

  window.__swRepairCartProps = repairCartProps;

  /* ── KwikEngage pid= landing ─────────────────────────────────
     theme.liquid ka <head> wala inline script URL se `pid` hata kar
     variant ids window.__swPidLanding me rakh deta hai (GoKwik ko pid
     milta hi nahi, isliye wo apna checkout khud nahi kholta). Yahan hum
     wahi items khud cart me daalte hain, pincode maangte hain, saari
     mandatory properties bharte hain aur cart drawer kholte hain.
     Customer phir normal GoKwik button se checkout karta hai — jahan
     swCartReadyForGoKwik() gate laga hai. */
  async function handlePidLanding() {
    var ids = window.__swPidLanding;
    window.__swPidLanding = null;
    if (!ids || !ids.length) return false;

    try {
      var cart = await getCart();
      var have = {};
      (cart.items || []).forEach(function (it) { have[String(it.variant_id)] = true; });
      var items = ids.filter(function (id) { return !have[String(id)]; })
                     .map(function (id) { return { id: Number(id), quantity: 1 }; });
      if (items.length) {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!r.ok) console.error('🔧 pid landing: cart/add failed', r.status, await r.text());
        else console.log('🔧 pid landing: added', items.length, 'item(s) from KwikEngage link');
      }
    } catch (e) {
      console.error('🔧 pid landing: add failed', e);
    }

    await repairCartProps({ askPincode: true });
    openCartDrawer();
    return true;
  }

  function openCartDrawer() {
    try {
      if (window.swRefreshCartDrawer) window.swRefreshCartDrawer({ delay: 0 });
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      var icon = document.querySelector('[data-cart-drawer-trigger], .header-actions__cart-icon, a[href="/cart"]');
      if (icon) { icon.click(); return; }
    } catch (e) {}
    window.location.href = '/cart';
  }

  /* ── Auto-run ────────────────────────────────────────────────
     v4: cart events (cart:updated / cart:refresh / sleep-setup:cart-changed)
     par ab auto-repair NAHI chalta. Har /cart/change.js theme ke native
     cart drawer ko re-render karta hai — page load / har cart change par
     repair chalane se drawer baar-baar "hilta" tha. Ab repair sirf:
       1. KwikEngage pid= landing par (items khud add karne ke baad), aur
       2. checkout click par — theme.liquid ka swCartReadyForGoKwik()
          window.__swRepairCartProps({ askPincode: true }) call karta hai.
     ─────────────────────────────────────────────────────────────── */
  function start() {
    if (window.__swPidLanding && window.__swPidLanding.length) handlePidLanding();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  console.log('🔧 Cart props auto-repair v7 — active (mandatory: ' + REQUIRED_KEYS.join(', ') + ')');
})();
